export default __webpack_public_path__ + "static/media/BT.ccb163c0.svg";